import { GeistMono } from "geist/font/mono";
import { GeistPixelSquare } from "geist/font/pixel";
import { GeistSans } from "geist/font/sans";

type FontDefinition = {
  label: string;
  stack: string;
};

export const fontRegistry = {
  geist: {
    label: "Geist",
    stack: 'var(--font-geist-sans), "Geist Sans", system-ui, sans-serif',
  },
  inter: {
    label: "Inter",
    stack: 'Inter, "SF Pro Display", "Segoe UI", system-ui, sans-serif',
  },
  notoSans: {
    label: "Noto Sans",
    stack: '"Noto Sans", "Noto Sans Arabic", system-ui, sans-serif',
  },
  nunitoSans: {
    label: "Nunito Sans",
    stack: '"Nunito Sans", "Segoe UI", system-ui, sans-serif',
  },
  figtree: {
    label: "Figtree",
    stack: 'Figtree, "SF Pro Display", system-ui, sans-serif',
  },
  roboto: {
    label: "Roboto",
    stack: 'Roboto, "Segoe UI", system-ui, sans-serif',
  },
  rubik: {
    label: "Rubik",
    stack: 'Rubik, "Noto Sans Arabic", "Segoe UI", system-ui, sans-serif',
  },
  raleway: {
    label: "Raleway",
    stack: 'Raleway, "Segoe UI", system-ui, sans-serif',
  },
  dmSans: {
    label: "DM Sans",
    stack: '"DM Sans", "SF Pro Display", system-ui, sans-serif',
  },
  publicSans: {
    label: "Public Sans",
    stack: '"Public Sans", "Segoe UI", system-ui, sans-serif',
  },
  outfit: {
    label: "Outfit",
    stack: 'Outfit, "Segoe UI", system-ui, sans-serif',
  },
  geistMono: {
    label: "Geist Mono",
    stack: 'var(--font-geist-mono), "Geist Mono", ui-monospace, monospace',
  },
  geistPixelSquare: {
    label: "Geist Pixel Square",
    stack: 'var(--font-geist-pixel-square), var(--font-geist-mono), "Geist Mono", ui-monospace, monospace',
  },
  jetBrainsMono: {
    label: "JetBrains Mono",
    stack: '"JetBrains Mono", var(--font-geist-mono), ui-monospace, monospace',
  },
  notoSerif: {
    label: "Noto Serif",
    stack: '"Noto Serif", Georgia, serif',
  },
  robotoSlab: {
    label: "Roboto Slab",
    stack: '"Roboto Slab", Georgia, serif',
  },
  merriweather: {
    label: "Merriweather",
    stack: "Merriweather, Georgia, serif",
  },
  lora: {
    label: "Lora",
    stack: "Lora, Georgia, serif",
  },
  playfairDisplay: {
    label: "Playfair Display",
    stack: '"Playfair Display", Georgia, serif',
  },
  alexandria: {
    label: "Alexandria",
    stack: 'Alexandria, "Noto Sans Arabic", "Segoe UI", system-ui, sans-serif',
  },
} as const satisfies Record<string, FontDefinition>;

export type FontKey = keyof typeof fontRegistry;

export const fontVars = [GeistSans.variable, GeistMono.variable, GeistPixelSquare.variable].join(" ");

export const fontOptions = (Object.entries(fontRegistry) as Array<[FontKey, (typeof fontRegistry)[FontKey]]>).map(
  ([key, font]) => ({
    key,
    label: font.label,
    stack: font.stack,
  }),
);
